import { render, staticRenderFns } from "./colorSelect.vue?vue&type=template&id=f3d59734&"
import script from "./colorSelect.vue?vue&type=script&lang=ts&"
export * from "./colorSelect.vue?vue&type=script&lang=ts&"
import style0 from "./colorSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports